import React, { useEffect, useRef, useState } from 'react'
import exampleImg from '../../img/example.png'
import Chatting from './Chat'
import useEstimateStore, { Estimate } from '../../stores/estimate'
import DateTimePicker from '../../components/DateTimeInputComponent'
import axios from 'axios'
import useAccountStore from '../../stores/account'
import useNoteStore, { Note } from '../../stores/note'
import { BASEURL } from '../../config'
import CreateOpinionPopup from '../../components/CreateOpinionPopup'
import NoteHistoryPopup from '../../components/NoteHistoryPopup'

const NotePage = (props:any) => {
    const {estimateList, curEsti, setEstimate, curHistory, setHistory} = useEstimateStore()
    const {accessToken} = useAccountStore()
    const {noteList, setNoteList} = useNoteStore()
    const [showCreateOpinionPopup, setShowCreateOpinionPopup] = useState(false)
    const [showNoteHistoryPopup, setShowNoteHistoryPopup] = useState(false)
    const popRef = useRef<HTMLDivElement>(null)
    const popRef2 = useRef<HTMLDivElement>(null)
    
    const male = '남'
    const female = '여'
    const neuteredMale = '중성화 남'
    const neuteredFemale = '중성화 여'
    const genderMap: { [key: string]: number } = { 
        [male]: 1, [female]: 2, [neuteredMale]: 3, [neuteredFemale]: 4 }
        
    const [coordinates, setCoordinates] = useState({ top: 0, left: 0 })

    useEffect(() => {
        const updateCoordinates = () => {

            const windowHeight = window.innerHeight
            const windowWidth = window.innerWidth
    
            // 임시 위치 조정
            const newTop = windowHeight / 2
            const newLeft = windowWidth / 2
            setCoordinates({ top: newTop, left: newLeft })
        }

        updateCoordinates() // 처음 로드 시 위치 업데이트
        window.addEventListener('resize', updateCoordinates) // 창 크기 변경 시 위치 업데이트

        return () => window.removeEventListener('resize', updateCoordinates)
    }, [])


    const handleEstiClick = (estimate:any) => { 
        setEstimate(estimate) 
        setHistory(null)
    }
 
    useEffect(()=> {
        if(!accessToken) return
        getNoteList()
    },[accessToken])
    
    const getNoteList = () => {
        axios.get(`${BASEURL}/note/list`, { headers: {Authorization: `Bearer ${accessToken}`, }})
        .then(response => response.data)
        .then(obj => {
            if(obj.status === "success") { setNoteList(obj.data) }
        }).catch(error => {
            setNoteList([])

            if(error.response) {
                // temp error handling
                if(error.response.status === 401) console.log("토큰이 만료되었습니다.")
                if(error.response.status === 403) console.log("토큰이 유효하지 않습니다.")
                if(error.response.status === 404) console.log("사용자 정보를 찾을 수 없습니다.")
            }
            else { console.log(error) }
        })
    }

    const AnsweredList = () => {
        const isAnswerItem = (data:any) => data.status === 'presented'
        const AnswerEstis = estimateList.filter((data)=> isAnswerItem(data))

        return (
            <div className="answ_list">
                <span className="circle"></span><span className="tit">답변</span>
                <ul>
                    {
                        AnswerEstis.length > 0 ? (
                            AnswerEstis.map((esti)=>{
                                return (<li className={`item ${esti.id === curEsti?.id  ? 'on' : ''}`} onClick={()=>handleEstiClick(esti)}><a href="#">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                  <path d="M13.0981 10.6338L11 9.42285V5C11 4.73478 10.8946 4.48043 10.7071 4.29289C10.5196 4.10536 10.2652 4 10 4C9.73479 4 9.48043 4.10536 9.2929 4.29289C9.10536 4.48043 9 4.73478 9 5V10C8.99996 10.1756 9.04614 10.3481 9.13391 10.5001C9.22168 10.6522 9.34795 10.7784 9.5 10.8662L12.0981 12.3662C12.2119 12.432 12.3375 12.4746 12.4678 12.4918C12.598 12.509 12.7304 12.5004 12.8573 12.4664C12.9842 12.4324 13.1032 12.3737 13.2074 12.2938C13.3117 12.2138 13.3991 12.114 13.4648 12.0003C13.5305 11.8865 13.5731 11.7608 13.5902 11.6306C13.6073 11.5003 13.5986 11.368 13.5646 11.2411C13.5305 11.1142 13.4718 10.9952 13.3918 10.891C13.3117 10.7868 13.212 10.6994 13.0981 10.6338ZM10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433284 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34874 18.9425 4.80691 17.0678 2.93219C15.1931 1.05746 12.6513 0.00294858 10 0ZM10 18C8.41775 18 6.87104 17.5308 5.55544 16.6518C4.23985 15.7727 3.21447 14.5233 2.60897 13.0615C2.00347 11.5997 1.84504 9.99113 2.15372 8.43928C2.4624 6.88743 3.22433 5.46197 4.34315 4.34315C5.46197 3.22433 6.88743 2.4624 8.43928 2.15372C9.99113 1.84504 11.5997 2.00346 13.0615 2.60896C14.5233 3.21447 15.7727 4.23984 16.6518 5.55544C17.5308 6.87103 18 8.41775 18 10C17.9976 12.121 17.1539 14.1544 15.6542 15.6542C14.1544 17.1539 12.121 17.9976 10 18Z" fill="#E0E0E0"/>
                                </svg>
                                <span className="name">{esti.userInfo.petName}</span>
                                <span className="gender">{esti.userInfo.petGender ? "남" : "여"}</span>
                                <span className="time">{new Date(esti.createdAt).toLocaleTimeString('ko-KR', {timeZone: 'Asia/Seoul', hour: '2-digit', minute: '2-digit', hour12: false})}</span>
                                </a></li>)
                            })
                        ) :
                        <div> 요청 없음 </div>
                    }
                </ul>
            </div>
        )
    }

    const ReservedList = () => {
        const isReservedItem = (data:any) => data.status === 'reserved'
        const ReservedEstis = estimateList.filter((data)=> isReservedItem(data))
        return (
            <div className="resv_list">
                       <span className="circle"></span><span className="tit">예약</span>
                       <ul>
                        {
                            ReservedEstis.length > 0 ? (
                                ReservedEstis.map((esti)=>{
                                    return (<li className={`item ${esti.id === curEsti?.id  ? 'on' : ''}`} onClick={()=>handleEstiClick(esti)}><a href="#">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M13.0981 10.6338L11 9.42285V5C11 4.73478 10.8946 4.48043 10.7071 4.29289C10.5196 4.10536 10.2652 4 10 4C9.73479 4 9.48043 4.10536 9.2929 4.29289C9.10536 4.48043 9 4.73478 9 5V10C8.99996 10.1756 9.04614 10.3481 9.13391 10.5001C9.22168 10.6522 9.34795 10.7784 9.5 10.8662L12.0981 12.3662C12.2119 12.432 12.3375 12.4746 12.4678 12.4918C12.598 12.509 12.7304 12.5004 12.8573 12.4664C12.9842 12.4324 13.1032 12.3737 13.2074 12.2938C13.3117 12.2138 13.3991 12.114 13.4648 12.0003C13.5305 11.8865 13.5731 11.7608 13.5902 11.6306C13.6073 11.5003 13.5986 11.368 13.5646 11.2411C13.5305 11.1142 13.4718 10.9952 13.3918 10.891C13.3117 10.7868 13.212 10.6994 13.0981 10.6338ZM10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433284 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34874 18.9425 4.80691 17.0678 2.93219C15.1931 1.05746 12.6513 0.00294858 10 0ZM10 18C8.41775 18 6.87104 17.5308 5.55544 16.6518C4.23985 15.7727 3.21447 14.5233 2.60897 13.0615C2.00347 11.5997 1.84504 9.99113 2.15372 8.43928C2.4624 6.88743 3.22433 5.46197 4.34315 4.34315C5.46197 3.22433 6.88743 2.4624 8.43928 2.15372C9.99113 1.84504 11.5997 2.00346 13.0615 2.60896C14.5233 3.21447 15.7727 4.23984 16.6518 5.55544C17.5308 6.87103 18 8.41775 18 10C17.9976 12.121 17.1539 14.1544 15.6542 15.6542C14.1544 17.1539 12.121 17.9976 10 18Z" fill="#E0E0E0"/>
                                    </svg>
                                    <span className="name">{esti.userInfo.petName}</span>
                                    <span className="gender">{esti.userInfo.petGender ? "남" : "여"}</span>
                                    <span className="time">{new Date(esti.createdAt).toLocaleTimeString('ko-KR', {timeZone: 'Asia/Seoul', hour: '2-digit', minute: '2-digit', hour12: false})}</span>
                                    </a></li>)
                                })
                            ) :
                            <div>요청 없음</div>
                        }
                        </ul>
                    </div>
        )
    }

    const CompleteList = () => {
        const isCompleteItem = (data:any) => data.status === 'completed'
        const CompletedEstis = estimateList.filter((data)=> isCompleteItem(data))
        return (
            <div className="complete_list">
                <span className="circle"></span><span className="tit">완료</span>
                <ul>
                    {
                        CompletedEstis.length > 0 ? (
                            CompletedEstis.map((esti)=>{
                                return (<li className={`item ${esti.id === curEsti?.id  ? 'on' : ''}`} onClick={()=>handleEstiClick(esti)}><a href="#">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M13.0981 10.6338L11 9.42285V5C11 4.73478 10.8946 4.48043 10.7071 4.29289C10.5196 4.10536 10.2652 4 10 4C9.73479 4 9.48043 4.10536 9.2929 4.29289C9.10536 4.48043 9 4.73478 9 5V10C8.99996 10.1756 9.04614 10.3481 9.13391 10.5001C9.22168 10.6522 9.34795 10.7784 9.5 10.8662L12.0981 12.3662C12.2119 12.432 12.3375 12.4746 12.4678 12.4918C12.598 12.509 12.7304 12.5004 12.8573 12.4664C12.9842 12.4324 13.1032 12.3737 13.2074 12.2938C13.3117 12.2138 13.3991 12.114 13.4648 12.0003C13.5305 11.8865 13.5731 11.7608 13.5902 11.6306C13.6073 11.5003 13.5986 11.368 13.5646 11.2411C13.5305 11.1142 13.4718 10.9952 13.3918 10.891C13.3117 10.7868 13.212 10.6994 13.0981 10.6338ZM10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433284 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34874 18.9425 4.80691 17.0678 2.93219C15.1931 1.05746 12.6513 0.00294858 10 0ZM10 18C8.41775 18 6.87104 17.5308 5.55544 16.6518C4.23985 15.7727 3.21447 14.5233 2.60897 13.0615C2.00347 11.5997 1.84504 9.99113 2.15372 8.43928C2.4624 6.88743 3.22433 5.46197 4.34315 4.34315C5.46197 3.22433 6.88743 2.4624 8.43928 2.15372C9.99113 1.84504 11.5997 2.00346 13.0615 2.60896C14.5233 3.21447 15.7727 4.23984 16.6518 5.55544C17.5308 6.87103 18 8.41775 18 10C17.9976 12.121 17.1539 14.1544 15.6542 15.6542C14.1544 17.1539 12.121 17.9976 10 18Z" fill="#E0E0E0"/>
                                </svg>
                                <span className="name">{esti.userInfo.petName}</span>
                                <span className="gender">{esti.userInfo.petGender ? "남" : "여"}</span>
                                <span className="time">{new Date(esti.createdAt).toLocaleTimeString('ko-KR', {timeZone: 'Asia/Seoul', hour: '2-digit', minute: '2-digit', hour12: false})}</span>
                                </a></li>)
                            })
                        ) :
                        <div>요청 없음</div>
                    }
                    </ul>
            </div>
        )
    }

    const InformationBar = () => {
        const {curEsti} = useEstimateStore()

        return (
            <div className="info">
                <div className="name"><span className="tit">반려동물</span>{curEsti?.userInfo?.petName ?? "이름"}</div>
                <div className="gender"><span className="tit">성별</span>{Object.keys(genderMap).find(key => genderMap[key] === curEsti?.userInfo?.petGender) ?? "구분없음"}</div>
                <div className="age"><span className="tit">나이</span>
                {curEsti?.userInfo?.petAge !== undefined && (<> 
                {curEsti.userInfo.petAge >= 12 && (<> {Math.floor(curEsti.userInfo.petAge / 12)}년{' '}</>)}
                {curEsti.userInfo.petAge % 12 > 0 && (<>{curEsti.userInfo.petAge % 12}개월</>)}</>)}</div>
                <div className="weight"><span className="tit">무게</span>{curEsti?.userInfo?.petWeight ?? 0}kg</div>
                <div className="guardian"><span className="tit">보호자</span>{curEsti?.userInfo?.guardianName ?? "보호자"}</div>
                <div className="phone"><span className="tit">전화번호</span>{curEsti?.userInfo?.guardianPhoneNumber ?? "010-0000-0000"}</div>
            </div> 
        )
    }
    
    
    // view, update는 note가 필수, create는 note가 필요없음, noteTitle은 필수로 받는 정보 (리렌더링 줄이기)
    interface RegisterNoteFormProps {
        noteTitle: string
        data?: Note | null
        createMode?: boolean
    }
    // 견적서 예약시간 : 변경불가
    const [reservedAt, setReservedAt] = useState<Date>(new Date(curEsti?.reservedAt??new Date()))
    useEffect(()=>{ if(curEsti) setReservedAt(new Date(curEsti?.reservedAt?? new Date()))},[curEsti])

    const RegisterNoteForm:React.FC<RegisterNoteFormProps>=({noteTitle = "", data = null, createMode = true}) => {
        // TODO: 수정 시, 이전 작성된 데이터와 비교 후 처리

        // 초기화 메서드
        const setContentState = () => {
            if(data) return data?.content
            else return ""
        }
        
        const setContentsState = () => {
            if(data) return [data.content1, data.content2, data.content3].filter(Boolean)
            else return []
        }
        
        const setDiagnosisTimeState = () => {
            if(data) return new Date(data?.diagnosisAt??new Date())
            return new Date(curEsti?.reservedAt??new Date())
        }

        // 초기화 메서드 끝

        const {curEsti} = useEstimateStore()
        const [isEdit, setEditMode] = useState(false)
        const [content, setContent] = useState(setContentState())
        const [contents, setContents] = useState(setContentsState()) // Note Image Link (if createMode, Image Data)
        const [diagnosisTime, setDiagnosisTime] = useState<Date>(setDiagnosisTimeState()) // 검사일

        const uploadImage = async(data: any, dataName:string) => {
            // dataUrl -> Blob -> File로 변환
            const dataUrlToBlob = (dataUrl: string) => {
                const arr = dataUrl.split(',')
                const mime = arr[0].match(/:(.*?);/)![1]
                const bstr = atob(arr[1])
                let n = bstr.length
                let u8arr = new Uint8Array(n)
                while(n--) { u8arr[n] = bstr.charCodeAt(n) }
                return new Blob([u8arr], { type: mime })
            }
            
            const blobToFile = (theBlob: Blob, fileName: string) => {
                const file = new File([theBlob], fileName, { type: theBlob.type })
                return file
            }
    
            // dataUrl -> Blob -> File로 변환끝
    
            // upload file to server
            let formData = new FormData()
            const blob = dataUrlToBlob(data)
            const file = blobToFile(blob, `${dataName}.png`)
            formData.append("file", file)
            formData.append("id", curEsti?.id.toString()?? "error")
            formData.append("type", "note")

            const url =  await axios.put(`${BASEURL}/auth/upload/file`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${accessToken}`,
                }
            }).then(response => {
                if (response.data.status === "success") {
                    return response.data.data
                } else { return '' }
            }).catch(error => {
                alert(`파일 업로드 실패: ${error.message}`)
                return ''
            })
            return url
        }

        const addImageData = (e:any) => {
            const reader = new FileReader()
            const file = e.target.files[0]
            reader.onloadend = async() => { 
                const newContents = [...contents]
                const url = await uploadImage(reader.result?.toString()??'', new Date().getTime().toString())
                if(!url) return

                newContents.push(url)
                setContents(newContents)
            }
            if (file) { reader.readAsDataURL(file) }
        }

        const removeImageData = (idx:number) => {
            const newContents = [...contents]
            newContents.splice(idx, 1)
            setContents(newContents)
        }

        const cancelEdit = () => {
            setContent(setContentState())
            setContents(setContentsState())
            setDiagnosisTime(setDiagnosisTimeState())
            setEditMode(false)
        }
        const startEdit = () => { setEditMode(true) }

        const registerNote = async() => {
            try {
                if(!curEsti) throw new Error("registerNote : curEsti is empty")
                if(!createMode) throw new Error("registerNote : createMode is not true")
                if(content === "") throw new Error("registerNote : content is empty")
                
                const noteInfo: any = {
                    estID: curHistory?.id || curEsti.id,
                    title: noteTitle || "Note Title",
                    content: content,
                    content1: contents[0] || null,
                    content2: contents[1] || null,
                    content3: contents[2] || null,
                    diagnosisAt: diagnosisTime
                }
                // title이 없으면, noteInfo에서 제거
                if(noteTitle === "") delete noteInfo.title

                // create note
                axios.post(`${BASEURL}/note/create`, {noteInfo : noteInfo},{ headers: {Authorization: `Bearer ${accessToken}`, }})
                .then(response => response.data)
                .then(obj => {
                    if(obj.status === "success") { 
                        alert("노트 등록이 완료됐습니다.")
                        // TODO: refresh note list
                        getNoteList()
                    }
                }).catch(error => {
                    if(error.response) {
                        // temp error handling
                        if(error.response.status === 401) console.log("토큰이 만료되었습니다.")
                        if(error.response.status === 403) console.log("토큰이 유효하지 않습니다.")
                        if(error.response.status === 404) console.log("사용자 정보를 찾을 수 없습니다.")
                    }
                    else { console.log(error) }
                })
            }
            catch(e){
                alert("노트 등록에 실패했습니다.")
                console.error(e)
            }
        }

        const editNote = async() => {
            try {
                if(!curEsti) throw new Error("editNote : curEsti is empty")
                if(createMode) throw new Error("editNote : createMode is not false")
                if(content === "") throw new Error("editNote : content is empty")
                
                const noteInfo: any = {
                    noteID: data?.noteID,
                    title: noteTitle || "Note Title",
                    content: content,
                    content1 : contents[0] || null,
                    content2 : contents[1] || null,
                    content3 : contents[2] || null,
                    diagnosisAt: diagnosisTime
                }
                // title이 없으면, noteInfo에서 제거
                if(noteTitle === "") delete noteInfo.title
                
                // update note
                axios.put(`${BASEURL}/note/update`, {noteInfo : noteInfo},{ headers: {Authorization: `Bearer ${accessToken}`, }})
                .then(response => response.data)
                .then(obj => {
                    if(obj.status === "success") { 
                        // refresh note list
                        alert("노트 수정이 완료됐습니다.")
                        setEditMode(false)
                        getNoteList()
                    }
                }).catch(error => {
                    if(error.response) {
                        // temp error handling
                        if(error.response.status === 401) console.log("토큰이 만료되었습니다.")
                        if(error.response.status === 403) console.log("토큰이 유효하지 않습니다.")
                        if(error.response.status === 404) console.log("사용자 정보를 찾을 수 없습니다.")
                    }
                    else { console.log(error) }
                })
            }
            catch(e){
                alert("노트 수정에 실패했습니다.")
                console.error(e)
            }
        }
        // view & update mode : note 필수, isEdit으로 토글
        if(!createMode)
            return (
            <div className="register_form">
                <div className="timer">
                    <label htmlFor="time">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                        <path d="M7.2 9.6C6.97333 9.6 6.78347 9.5232 6.6304 9.3696C6.4768 9.21653 6.4 9.02667 6.4 8.8C6.4 8.57333 6.4768 8.3832 6.6304 8.2296C6.78347 8.07653 6.97333 8 7.2 8C7.42667 8 7.6168 8.07653 7.7704 8.2296C7.92347 8.3832 8 8.57333 8 8.8C8 9.02667 7.92347 9.21653 7.7704 9.3696C7.6168 9.5232 7.42667 9.6 7.2 9.6ZM4 9.6C3.77333 9.6 3.5832 9.5232 3.4296 9.3696C3.27653 9.21653 3.2 9.02667 3.2 8.8C3.2 8.57333 3.27653 8.3832 3.4296 8.2296C3.5832 8.07653 3.77333 8 4 8C4.22667 8 4.4168 8.07653 4.5704 8.2296C4.72347 8.3832 4.8 8.57333 4.8 8.8C4.8 9.02667 4.72347 9.21653 4.5704 9.3696C4.4168 9.5232 4.22667 9.6 4 9.6ZM10.4 9.6C10.1733 9.6 9.98347 9.5232 9.8304 9.3696C9.6768 9.21653 9.6 9.02667 9.6 8.8C9.6 8.57333 9.6768 8.3832 9.8304 8.2296C9.98347 8.07653 10.1733 8 10.4 8C10.6267 8 10.8165 8.07653 10.9696 8.2296C11.1232 8.3832 11.2 8.57333 11.2 8.8C11.2 9.02667 11.1232 9.21653 10.9696 9.3696C10.8165 9.5232 10.6267 9.6 10.4 9.6ZM7.2 12.8C6.97333 12.8 6.78347 12.7232 6.6304 12.5696C6.4768 12.4165 6.4 12.2267 6.4 12C6.4 11.7733 6.4768 11.5835 6.6304 11.4304C6.78347 11.2768 6.97333 11.2 7.2 11.2C7.42667 11.2 7.6168 11.2768 7.7704 11.4304C7.92347 11.5835 8 11.7733 8 12C8 12.2267 7.92347 12.4165 7.7704 12.5696C7.6168 12.7232 7.42667 12.8 7.2 12.8ZM4 12.8C3.77333 12.8 3.5832 12.7232 3.4296 12.5696C3.27653 12.4165 3.2 12.2267 3.2 12C3.2 11.7733 3.27653 11.5835 3.4296 11.4304C3.5832 11.2768 3.77333 11.2 4 11.2C4.22667 11.2 4.4168 11.2768 4.5704 11.4304C4.72347 11.5835 4.8 11.7733 4.8 12C4.8 12.2267 4.72347 12.4165 4.5704 12.5696C4.4168 12.7232 4.22667 12.8 4 12.8ZM10.4 12.8C10.1733 12.8 9.98347 12.7232 9.8304 12.5696C9.6768 12.4165 9.6 12.2267 9.6 12C9.6 11.7733 9.6768 11.5835 9.8304 11.4304C9.98347 11.2768 10.1733 11.2 10.4 11.2C10.6267 11.2 10.8165 11.2768 10.9696 11.4304C11.1232 11.5835 11.2 11.7733 11.2 12C11.2 12.2267 11.1232 12.4165 10.9696 12.5696C10.8165 12.7232 10.6267 12.8 10.4 12.8ZM1.6 16C1.16 16 0.7832 15.8435 0.4696 15.5304C0.156533 15.2168 0 14.84 0 14.4V3.2C0 2.76 0.156533 2.38347 0.4696 2.0704C0.7832 1.7568 1.16 1.6 1.6 1.6H2.4V0H4V1.6H10.4V0H12V1.6H12.8C13.24 1.6 13.6168 1.7568 13.9304 2.0704C14.2435 2.38347 14.4 2.76 14.4 3.2V14.4C14.4 14.84 14.2435 15.2168 13.9304 15.5304C13.6168 15.8435 13.24 16 12.8 16H1.6ZM1.6 14.4H12.8V6.4H1.6V14.4Z" fill="black"/>
                        </svg>
                        <p>검사 접종일</p>
                    </label>
                    <DateTimePicker selectedDate={diagnosisTime} setSelectedDate={setDiagnosisTime} disabled={!isEdit}/>
                </div>
                <div className="texter">
                    <textarea cols={30} rows={10} placeholder="메모를 입력해주세요." 
                    value={content} onChange={(e)=>setContent(e.target.value)} disabled={!isEdit}/>
                </div>
                <div className="bottom">
                    <div className="add_box">
                        {/** 파일 첨부시 미리보기, 이미지,영상 첨부 몇개까지 가능할지.. */}
                        { 
                        contents.map((content, idx) => {
                            return ( <div className="preview">
                                <img src={content??exampleImg} alt="미리보기"/>
                                {isEdit && <a href="#" className="delete_btn" onClick={()=>removeImageData(idx)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                        <path d="M4.58731 4.00008L7.21231 1.37924C7.29077 1.30078 7.33485 1.19437 7.33485 1.08341C7.33485 0.972452 7.29077 0.866037 7.21231 0.787577C7.13385 0.709117 7.02744 0.665039 6.91648 0.665039C6.80552 0.665039 6.69911 0.709117 6.62065 0.787577L3.99981 3.41258L1.37898 0.787577C1.30052 0.709117 1.1941 0.665039 1.08315 0.665039C0.972186 0.665039 0.865772 0.709117 0.787312 0.787577C0.708852 0.866037 0.664774 0.972452 0.664774 1.08341C0.664774 1.19437 0.708852 1.30078 0.787312 1.37924L3.41231 4.00008L0.787312 6.62091C0.748258 6.65965 0.717261 6.70573 0.696107 6.7565C0.674954 6.80728 0.664062 6.86174 0.664062 6.91674C0.664062 6.97175 0.674954 7.02621 0.696107 7.07698C0.717261 7.12776 0.748258 7.17384 0.787312 7.21258C0.826046 7.25163 0.87213 7.28263 0.922905 7.30378C0.97368 7.32494 1.02814 7.33583 1.08315 7.33583C1.13815 7.33583 1.19261 7.32494 1.24339 7.30378C1.29416 7.28263 1.34024 7.25163 1.37898 7.21258L3.99981 4.58758L6.62065 7.21258C6.65938 7.25163 6.70546 7.28263 6.75624 7.30378C6.80701 7.32494 6.86147 7.33583 6.91648 7.33583C6.97148 7.33583 7.02594 7.32494 7.07672 7.30378C7.12749 7.28263 7.17358 7.25163 7.21231 7.21258C7.25137 7.17384 7.28236 7.12776 7.30352 7.07698C7.32467 7.02621 7.33556 6.97175 7.33556 6.91674C7.33556 6.86174 7.32467 6.80728 7.30352 6.7565C7.28236 6.70573 7.25137 6.65965 7.21231 6.62091L4.58731 4.00008Z" fill="white"/>
                                    </svg>
                                </a>}
                            </div>
                            )
                        })}
                        
                        {isEdit && (
                            contents.length < 3 && <>
                            <label htmlFor="add_file">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M19 10C18.7348 10 18.4804 10.1054 18.2929 10.2929C18.1054 10.4804 18 10.7348 18 11V14.38L16.52 12.9C15.9974 12.3815 15.2911 12.0906 14.555 12.0906C13.8189 12.0906 13.1126 12.3815 12.59 12.9L11.89 13.61L9.41 11.12C8.88742 10.6015 8.18113 10.3106 7.445 10.3106C6.70887 10.3106 6.00258 10.6015 5.48 11.12L4 12.61V7C4 6.73478 4.10536 6.48043 4.29289 6.29289C4.48043 6.10536 4.73478 6 5 6H13C13.2652 6 13.5196 5.89464 13.7071 5.70711C13.8946 5.51957 14 5.26522 14 5C14 4.73478 13.8946 4.48043 13.7071 4.29289C13.5196 4.10536 13.2652 4 13 4H5C4.20435 4 3.44129 4.31607 2.87868 4.87868C2.31607 5.44129 2 6.20435 2 7V19.22C2.00264 19.9565 2.29637 20.6621 2.81715 21.1828C3.33794 21.7036 4.04351 21.9974 4.78 22H17.22C17.491 21.9978 17.7603 21.9574 18.02 21.88C18.5974 21.718 19.1058 21.3711 19.4671 20.8924C19.8283 20.4137 20.0226 19.8297 20.02 19.23V11C20.02 10.867 19.9935 10.7353 19.942 10.6126C19.8905 10.49 19.8151 10.3789 19.7201 10.2857C19.6251 10.1926 19.5125 10.1194 19.3888 10.0703C19.2652 10.0212 19.133 9.99734 19 10ZM5 20C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V15.43L6.89 12.54C7.03615 12.3947 7.23389 12.3131 7.44 12.3131C7.64611 12.3131 7.84385 12.3947 7.99 12.54L15.46 20H5ZM18 19C17.9936 19.1936 17.931 19.3812 17.82 19.54L13.3 15L14.01 14.3C14.0817 14.2268 14.1673 14.1687 14.2617 14.129C14.3561 14.0893 14.4576 14.0689 14.56 14.0689C14.6624 14.0689 14.7639 14.0893 14.8583 14.129C14.9527 14.1687 15.0383 14.2268 15.11 14.3L18 17.21V19ZM21 4H20V3C20 2.73478 19.8946 2.48043 19.7071 2.29289C19.5196 2.10536 19.2652 2 19 2C18.7348 2 18.4804 2.10536 18.2929 2.29289C18.1054 2.48043 18 2.73478 18 3V4H17C16.7348 4 16.4804 4.10536 16.2929 4.29289C16.1054 4.48043 16 4.73478 16 5C16 5.26522 16.1054 5.51957 16.2929 5.70711C16.4804 5.89464 16.7348 6 17 6H18V7C18 7.26522 18.1054 7.51957 18.2929 7.70711C18.4804 7.89464 18.7348 8 19 8C19.2652 8 19.5196 7.89464 19.7071 7.70711C19.8946 7.51957 20 7.26522 20 7V6H21C21.2652 6 21.5196 5.89464 21.7071 5.70711C21.8946 5.51957 22 5.26522 22 5C22 4.73478 21.8946 4.48043 21.7071 4.29289C21.5196 4.10536 21.2652 4 21 4Z" fill="#C4C4C4"/>
                            </svg>
                            </label>
                            <input type="file" id="add_file" onChange={addImageData}/>
                        </>)}
                    </div>
                    <div className="btn_box">
                        {!isEdit && <button type="button" id="round_btn" onClick={startEdit}>수정하기</button>}
                        { isEdit && <button type="button" id="round_btn" onClick={editNote}>수정완료</button>}
                        { isEdit && <button type="button" id="round_btn" onClick={cancelEdit}>취소</button>}
                    </div>
                </div>
            </div>)

        return (
        <div className="register_form">
            <div className="timer">
                <label htmlFor="time">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                    <path d="M7.2 9.6C6.97333 9.6 6.78347 9.5232 6.6304 9.3696C6.4768 9.21653 6.4 9.02667 6.4 8.8C6.4 8.57333 6.4768 8.3832 6.6304 8.2296C6.78347 8.07653 6.97333 8 7.2 8C7.42667 8 7.6168 8.07653 7.7704 8.2296C7.92347 8.3832 8 8.57333 8 8.8C8 9.02667 7.92347 9.21653 7.7704 9.3696C7.6168 9.5232 7.42667 9.6 7.2 9.6ZM4 9.6C3.77333 9.6 3.5832 9.5232 3.4296 9.3696C3.27653 9.21653 3.2 9.02667 3.2 8.8C3.2 8.57333 3.27653 8.3832 3.4296 8.2296C3.5832 8.07653 3.77333 8 4 8C4.22667 8 4.4168 8.07653 4.5704 8.2296C4.72347 8.3832 4.8 8.57333 4.8 8.8C4.8 9.02667 4.72347 9.21653 4.5704 9.3696C4.4168 9.5232 4.22667 9.6 4 9.6ZM10.4 9.6C10.1733 9.6 9.98347 9.5232 9.8304 9.3696C9.6768 9.21653 9.6 9.02667 9.6 8.8C9.6 8.57333 9.6768 8.3832 9.8304 8.2296C9.98347 8.07653 10.1733 8 10.4 8C10.6267 8 10.8165 8.07653 10.9696 8.2296C11.1232 8.3832 11.2 8.57333 11.2 8.8C11.2 9.02667 11.1232 9.21653 10.9696 9.3696C10.8165 9.5232 10.6267 9.6 10.4 9.6ZM7.2 12.8C6.97333 12.8 6.78347 12.7232 6.6304 12.5696C6.4768 12.4165 6.4 12.2267 6.4 12C6.4 11.7733 6.4768 11.5835 6.6304 11.4304C6.78347 11.2768 6.97333 11.2 7.2 11.2C7.42667 11.2 7.6168 11.2768 7.7704 11.4304C7.92347 11.5835 8 11.7733 8 12C8 12.2267 7.92347 12.4165 7.7704 12.5696C7.6168 12.7232 7.42667 12.8 7.2 12.8ZM4 12.8C3.77333 12.8 3.5832 12.7232 3.4296 12.5696C3.27653 12.4165 3.2 12.2267 3.2 12C3.2 11.7733 3.27653 11.5835 3.4296 11.4304C3.5832 11.2768 3.77333 11.2 4 11.2C4.22667 11.2 4.4168 11.2768 4.5704 11.4304C4.72347 11.5835 4.8 11.7733 4.8 12C4.8 12.2267 4.72347 12.4165 4.5704 12.5696C4.4168 12.7232 4.22667 12.8 4 12.8ZM10.4 12.8C10.1733 12.8 9.98347 12.7232 9.8304 12.5696C9.6768 12.4165 9.6 12.2267 9.6 12C9.6 11.7733 9.6768 11.5835 9.8304 11.4304C9.98347 11.2768 10.1733 11.2 10.4 11.2C10.6267 11.2 10.8165 11.2768 10.9696 11.4304C11.1232 11.5835 11.2 11.7733 11.2 12C11.2 12.2267 11.1232 12.4165 10.9696 12.5696C10.8165 12.7232 10.6267 12.8 10.4 12.8ZM1.6 16C1.16 16 0.7832 15.8435 0.4696 15.5304C0.156533 15.2168 0 14.84 0 14.4V3.2C0 2.76 0.156533 2.38347 0.4696 2.0704C0.7832 1.7568 1.16 1.6 1.6 1.6H2.4V0H4V1.6H10.4V0H12V1.6H12.8C13.24 1.6 13.6168 1.7568 13.9304 2.0704C14.2435 2.38347 14.4 2.76 14.4 3.2V14.4C14.4 14.84 14.2435 15.2168 13.9304 15.5304C13.6168 15.8435 13.24 16 12.8 16H1.6ZM1.6 14.4H12.8V6.4H1.6V14.4Z" fill="black"/>
                    </svg>
                    <p>검사 접종일</p>
                </label>
                <DateTimePicker selectedDate={diagnosisTime} setSelectedDate={setDiagnosisTime}/>
            </div>
            <div className="texter">
                <textarea cols={30} rows={10} placeholder="메모를 입력해주세요." value={content} onChange={(e)=>setContent(e.target.value)}/>
            </div>
            <div className="bottom">
                <div className="add_box">
                {/** 파일 첨부시 미리보기, 이미지,영상 첨부 몇개까지 가능할지.. */}
                { 
                    contents.map((data, idx) => {
                        return ( <div className="preview">
                            <img src={data??exampleImg} alt="미리보기"/>
                            <a href="#" className="delete_btn" onClick={()=>removeImageData(idx)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                    <path d="M4.58731 4.00008L7.21231 1.37924C7.29077 1.30078 7.33485 1.19437 7.33485 1.08341C7.33485 0.972452 7.29077 0.866037 7.21231 0.787577C7.13385 0.709117 7.02744 0.665039 6.91648 0.665039C6.80552 0.665039 6.69911 0.709117 6.62065 0.787577L3.99981 3.41258L1.37898 0.787577C1.30052 0.709117 1.1941 0.665039 1.08315 0.665039C0.972186 0.665039 0.865772 0.709117 0.787312 0.787577C0.708852 0.866037 0.664774 0.972452 0.664774 1.08341C0.664774 1.19437 0.708852 1.30078 0.787312 1.37924L3.41231 4.00008L0.787312 6.62091C0.748258 6.65965 0.717261 6.70573 0.696107 6.7565C0.674954 6.80728 0.664062 6.86174 0.664062 6.91674C0.664062 6.97175 0.674954 7.02621 0.696107 7.07698C0.717261 7.12776 0.748258 7.17384 0.787312 7.21258C0.826046 7.25163 0.87213 7.28263 0.922905 7.30378C0.97368 7.32494 1.02814 7.33583 1.08315 7.33583C1.13815 7.33583 1.19261 7.32494 1.24339 7.30378C1.29416 7.28263 1.34024 7.25163 1.37898 7.21258L3.99981 4.58758L6.62065 7.21258C6.65938 7.25163 6.70546 7.28263 6.75624 7.30378C6.80701 7.32494 6.86147 7.33583 6.91648 7.33583C6.97148 7.33583 7.02594 7.32494 7.07672 7.30378C7.12749 7.28263 7.17358 7.25163 7.21231 7.21258C7.25137 7.17384 7.28236 7.12776 7.30352 7.07698C7.32467 7.02621 7.33556 6.97175 7.33556 6.91674C7.33556 6.86174 7.32467 6.80728 7.30352 6.7565C7.28236 6.70573 7.25137 6.65965 7.21231 6.62091L4.58731 4.00008Z" fill="white"/>
                                </svg>
                            </a>
                        </div>)
                })}
                {contents.length < 3 && 
                    <>
                    <label htmlFor="add_file">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M19 10C18.7348 10 18.4804 10.1054 18.2929 10.2929C18.1054 10.4804 18 10.7348 18 11V14.38L16.52 12.9C15.9974 12.3815 15.2911 12.0906 14.555 12.0906C13.8189 12.0906 13.1126 12.3815 12.59 12.9L11.89 13.61L9.41 11.12C8.88742 10.6015 8.18113 10.3106 7.445 10.3106C6.70887 10.3106 6.00258 10.6015 5.48 11.12L4 12.61V7C4 6.73478 4.10536 6.48043 4.29289 6.29289C4.48043 6.10536 4.73478 6 5 6H13C13.2652 6 13.5196 5.89464 13.7071 5.70711C13.8946 5.51957 14 5.26522 14 5C14 4.73478 13.8946 4.48043 13.7071 4.29289C13.5196 4.10536 13.2652 4 13 4H5C4.20435 4 3.44129 4.31607 2.87868 4.87868C2.31607 5.44129 2 6.20435 2 7V19.22C2.00264 19.9565 2.29637 20.6621 2.81715 21.1828C3.33794 21.7036 4.04351 21.9974 4.78 22H17.22C17.491 21.9978 17.7603 21.9574 18.02 21.88C18.5974 21.718 19.1058 21.3711 19.4671 20.8924C19.8283 20.4137 20.0226 19.8297 20.02 19.23V11C20.02 10.867 19.9935 10.7353 19.942 10.6126C19.8905 10.49 19.8151 10.3789 19.7201 10.2857C19.6251 10.1926 19.5125 10.1194 19.3888 10.0703C19.2652 10.0212 19.133 9.99734 19 10ZM5 20C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V15.43L6.89 12.54C7.03615 12.3947 7.23389 12.3131 7.44 12.3131C7.64611 12.3131 7.84385 12.3947 7.99 12.54L15.46 20H5ZM18 19C17.9936 19.1936 17.931 19.3812 17.82 19.54L13.3 15L14.01 14.3C14.0817 14.2268 14.1673 14.1687 14.2617 14.129C14.3561 14.0893 14.4576 14.0689 14.56 14.0689C14.6624 14.0689 14.7639 14.0893 14.8583 14.129C14.9527 14.1687 15.0383 14.2268 15.11 14.3L18 17.21V19ZM21 4H20V3C20 2.73478 19.8946 2.48043 19.7071 2.29289C19.5196 2.10536 19.2652 2 19 2C18.7348 2 18.4804 2.10536 18.2929 2.29289C18.1054 2.48043 18 2.73478 18 3V4H17C16.7348 4 16.4804 4.10536 16.2929 4.29289C16.1054 4.48043 16 4.73478 16 5C16 5.26522 16.1054 5.51957 16.2929 5.70711C16.4804 5.89464 16.7348 6 17 6H18V7C18 7.26522 18.1054 7.51957 18.2929 7.70711C18.4804 7.89464 18.7348 8 19 8C19.2652 8 19.5196 7.89464 19.7071 7.70711C19.8946 7.51957 20 7.26522 20 7V6H21C21.2652 6 21.5196 5.89464 21.7071 5.70711C21.8946 5.51957 22 5.26522 22 5C22 4.73478 21.8946 4.48043 21.7071 4.29289C21.5196 4.10536 21.2652 4 21 4Z" fill="#C4C4C4"/>
                        </svg>
                    </label>
                    <input type="file" id="add_file" onChange={addImageData}/>
                </>}
                </div>
                <div className="btn_box">
                    <button type="button" id="round_btn" onClick={registerNote}>등록</button>
                </div>
            </div>
        </div>
        )
    }

    const RegisterFormContainer = () => {
        const {curEsti, curHistory} = useEstimateStore()
        const [noteTitle, setNoteTitle] = useState("")
        useEffect(()=>{ if(curEsti) { setNoteTitle(noteList[0]?.title ??curEsti.title ?? "") }},[curEsti, noteList])

        return (
        <div className="register">
            <div className="diagnosis">
                <div className="top">
                    <div>
                        <span className="tit">진료기록</span>
                        <div className="option">        
                            <label htmlFor="title">제목</label>
                            <input className="title" type="text" placeholder="제목을 입력해주세요." 
                            value={noteTitle} onChange={(e)=>{setNoteTitle(e.target.value)}}/>
                        </div>
                    </div>
                    <button className="create_btn" onClick={()=>{setShowCreateOpinionPopup(true)}}> 소견서 작성 </button>
                </div>
                <div className="topper"> {/** 예약일, 검사 접종일 */}
                    <div className="timer">
                        <label htmlFor="reservation">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                            <path d="M7.2 9.6C6.97333 9.6 6.78347 9.5232 6.6304 9.3696C6.4768 9.21653 6.4 9.02667 6.4 8.8C6.4 8.57333 6.4768 8.3832 6.6304 8.2296C6.78347 8.07653 6.97333 8 7.2 8C7.42667 8 7.6168 8.07653 7.7704 8.2296C7.92347 8.3832 8 8.57333 8 8.8C8 9.02667 7.92347 9.21653 7.7704 9.3696C7.6168 9.5232 7.42667 9.6 7.2 9.6ZM4 9.6C3.77333 9.6 3.5832 9.5232 3.4296 9.3696C3.27653 9.21653 3.2 9.02667 3.2 8.8C3.2 8.57333 3.27653 8.3832 3.4296 8.2296C3.5832 8.07653 3.77333 8 4 8C4.22667 8 4.4168 8.07653 4.5704 8.2296C4.72347 8.3832 4.8 8.57333 4.8 8.8C4.8 9.02667 4.72347 9.21653 4.5704 9.3696C4.4168 9.5232 4.22667 9.6 4 9.6ZM10.4 9.6C10.1733 9.6 9.98347 9.5232 9.8304 9.3696C9.6768 9.21653 9.6 9.02667 9.6 8.8C9.6 8.57333 9.6768 8.3832 9.8304 8.2296C9.98347 8.07653 10.1733 8 10.4 8C10.6267 8 10.8165 8.07653 10.9696 8.2296C11.1232 8.3832 11.2 8.57333 11.2 8.8C11.2 9.02667 11.1232 9.21653 10.9696 9.3696C10.8165 9.5232 10.6267 9.6 10.4 9.6ZM7.2 12.8C6.97333 12.8 6.78347 12.7232 6.6304 12.5696C6.4768 12.4165 6.4 12.2267 6.4 12C6.4 11.7733 6.4768 11.5835 6.6304 11.4304C6.78347 11.2768 6.97333 11.2 7.2 11.2C7.42667 11.2 7.6168 11.2768 7.7704 11.4304C7.92347 11.5835 8 11.7733 8 12C8 12.2267 7.92347 12.4165 7.7704 12.5696C7.6168 12.7232 7.42667 12.8 7.2 12.8ZM4 12.8C3.77333 12.8 3.5832 12.7232 3.4296 12.5696C3.27653 12.4165 3.2 12.2267 3.2 12C3.2 11.7733 3.27653 11.5835 3.4296 11.4304C3.5832 11.2768 3.77333 11.2 4 11.2C4.22667 11.2 4.4168 11.2768 4.5704 11.4304C4.72347 11.5835 4.8 11.7733 4.8 12C4.8 12.2267 4.72347 12.4165 4.5704 12.5696C4.4168 12.7232 4.22667 12.8 4 12.8ZM10.4 12.8C10.1733 12.8 9.98347 12.7232 9.8304 12.5696C9.6768 12.4165 9.6 12.2267 9.6 12C9.6 11.7733 9.6768 11.5835 9.8304 11.4304C9.98347 11.2768 10.1733 11.2 10.4 11.2C10.6267 11.2 10.8165 11.2768 10.9696 11.4304C11.1232 11.5835 11.2 11.7733 11.2 12C11.2 12.2267 11.1232 12.4165 10.9696 12.5696C10.8165 12.7232 10.6267 12.8 10.4 12.8ZM1.6 16C1.16 16 0.7832 15.8435 0.4696 15.5304C0.156533 15.2168 0 14.84 0 14.4V3.2C0 2.76 0.156533 2.38347 0.4696 2.0704C0.7832 1.7568 1.16 1.6 1.6 1.6H2.4V0H4V1.6H10.4V0H12V1.6H12.8C13.24 1.6 13.6168 1.7568 13.9304 2.0704C14.2435 2.38347 14.4 2.76 14.4 3.2V14.4C14.4 14.84 14.2435 15.2168 13.9304 15.5304C13.6168 15.8435 13.24 16 12.8 16H1.6ZM1.6 14.4H12.8V6.4H1.6V14.4Z" fill="black"/>
                        </svg>
                            <p>예약일</p>
                        </label>
                        <div className="time_container" id="reservation">
                            <DateTimePicker selectedDate={reservedAt} setSelectedDate={setReservedAt} disabled={true}/>
                        </div>
                    </div>
                </div>
                <div className="form_container">
                    {noteList.filter((note)=>{
                        // curHistory의 존재여부와 일치하는 estID를 기반으로 노트를 필터링
                        if (curHistory) return note.estID === curHistory.id
                        else return note.estID === curEsti?.id
                    })
                    .map((note)=>{ return <RegisterNoteForm noteTitle={noteTitle} data={note} createMode={false}/>})}
                    <RegisterNoteForm noteTitle={noteTitle}/>
                </div>
            </div>
        </div>
        )
    }
    
    const NoteHistory = (props:any) => {
        const {data} = props
        const {curHistory, setHistory} = useEstimateStore()
        const setHistoryData = (data:Estimate) => {
            if(curHistory && curHistory.id === data.id) {
                setHistory(null)
                return
            }

            setHistory(data)
        }
        const formatDateToYYYYMMDD = (date:any) => {
            if (!date) return ""
          
            const d = new Date(date)
            const year = d.getFullYear()
            const month = (`0${d.getMonth() + 1}`).slice(-2) // 월은 0부터 시작하므로 1을 더해줍니다.
            const day = (`0${d.getDate()}`).slice(-2)
          
            return `${year}.${month}.${day}`
          }
        return (
            <li onClick={()=>setHistoryData(data)} style={{
                background: curHistory && curHistory.id === data.id ? "#f5f5f5" : "white"
            }}>
                <div className="top">
                    <div>
                        <span className="checkup">{ formatDateToYYYYMMDD(data.createdAt)} 검사·접종일</span>
                    </div>
                    <div>
                        <span className="hospital">안쿠마동물병원</span>
                        <span className="reservation">{formatDateToYYYYMMDD(data.reservedAt)} 예약</span>
                    </div>
                </div>
                {/** Note title */}
                <div>
                    <div className="chkup_con">
                        {data.description.length > 30 ? data.description.substring(0,30) + "..." : data.description}</div>
                    <div className="regis_insu">
                        {new Date().getUTCSeconds() % 2 == 0 ? "보험사 신청" : "보험사 완료"}
                    </div>
                </div>
                
            </li>
        )
    }

    const NoteHistoryContainer = () => {
        const {curEsti, estimateList} = useEstimateStore()
        const [noteHistory, setNoteHistory] = useState<Estimate[]>([])
        useEffect(()=>{
            if(curEsti) {
                const history = estimateList.filter(
                    (esti) => esti.userID === curEsti.userID && 
                                esti.status === "completed")
                setNoteHistory(history)
            } else {
                setNoteHistory([])
            }
        }, [curEsti])
        
        return (
            <>
                <div className="history">
                    <span className="tit">완료내역</span>
                    <ul>
                        { noteHistory.length > 0 ? 
                        noteHistory.map((item)=>{ return <NoteHistory data={item}/>}) : 
                        (<li> <div className="chkup_con">완료내역이 없습니다</div> </li>)}
                    </ul>
                </div>
            </>
        )
    }
    
    return (
        <>  
        <div className="contents">
            {/**  고객리스트 */}
                <div className="list">
                    <h2>고객리스트</h2>
                    {/** 답변 리스트 */}
                    <AnsweredList/>
                    {/** 예약 리스트 */}
                    <ReservedList/>
                    {/** 답변완료 리스트 */}
                    <CompleteList/>
            </div>
            {/** 수첩 기록 */}
                <div className="record">
                  <InformationBar/>
                  <div className={`note${curEsti == null || curEsti?.status=="presented" ? " disabled" :""}`}>
                      <RegisterFormContainer/>
                      <NoteHistoryContainer/>
                  </div> 
                </div>
            {/** 채팅방 */}
            <Chatting/>
        </div>
        <CreateOpinionPopup popRef={popRef}
        showCreateOpinionPopup={showCreateOpinionPopup}
        setShowCreateOpinionPopup={setShowCreateOpinionPopup}/>
        <NoteHistoryPopup popRef={popRef2}
        showNotePopup = {showNoteHistoryPopup}
        setShowNotePopup={setShowNoteHistoryPopup}
        coordinates={coordinates}/>
        </>
    )
}

export default NotePage
